import Color from 'color';

function RgbaToHex6(color: Color, background: Color = Color.rgb(255, 255, 255)) {
  const red = (1 - color.alpha()) * background.red() + color.alpha() * color.red();
  const green = (1 - color.alpha()) * background.green() + color.alpha() * color.green();
  const blue = (1 - color.alpha()) * background.blue() + color.alpha() * color.blue();

  return Color.rgb(red, green, blue).hex();
}

export function generateThemeColorList(name: string, baseColor: Color) {
  const template = {
    [name]: 1,
    [name + '4']: 0.04,
    [name + '8']: 0.08,
    [name + '12']: 0.12,
    [name + '16']: 0.16,
    [name + '24']: 0.24,
    [name + '32']: 0.32,
    [name + '48']: 0.48,
    [name + '64']: 0.64,
    [name + '80']: 0.8,
  };

  const result: Record<string, string> = {};

  for (const [name, opacity] of Object.entries(template)) {
    result[name] = RgbaToHex6(
      Color.rgb(baseColor.red(), baseColor.green(), baseColor.blue()).alpha(opacity),
    );
  }

  return result;
}

export function colorBrighter(baseColor: Color, alpha: number) {
  return RgbaToHex6(baseColor.alpha(alpha));
}
